<section class="px-6 py-20 sm:px-10">
  <div class="mx-auto max-w-md">
    @if (inviteCompetitionName(); as name) {
      <div class="mb-8">
        <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
          >You're invited</span
        >
        <h1 class="font-display text-3xl font-semibold text-parchment">
          Welcome to the {{ name }} competition
        </h1>
        <p class="mt-3 text-sm text-dusk">
          Already have an account? Log in below to join. Otherwise, use the
          <span class="text-parchment">Start free</span> link below to create one.
        </p>
      </div>
    } @else {
      <div class="mb-8">
        <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
          >Welcome back</span
        >
        <h1 class="font-display text-3xl font-semibold text-parchment">Log in to your pool</h1>
      </div>
    }

    <form
      [formGroup]="form"
      (ngSubmit)="submit()"
      class="flex flex-col gap-5 rounded-md border border-hairline bg-panel p-7"
    >
      <div class="flex flex-col gap-2">
        <label for="email" class="text-sm font-medium text-parchment">Email</label>
        <input
          id="email"
          type="email"
          formControlName="email"
          autocomplete="email"
          class="rounded border border-hairline bg-ink px-4 py-2.5 text-parchment placeholder:text-dusk/60 focus:border-gold focus:outline-none"
          placeholder="you@example.com"
        />
      </div>

      <div class="flex flex-col gap-2">
        <div class="flex items-center justify-between">
          <label for="password" class="text-sm font-medium text-parchment">Password</label>
          <a routerLink="/forgot-password" class="text-sm text-dusk hover:text-parchment">Forgot it?</a>
        </div>
        <app-password-field>
          <input
            id="password"
            appPasswordInput
            formControlName="password"
            autocomplete="current-password"
            class="w-full rounded border border-hairline bg-ink px-4 py-2.5 text-parchment placeholder:text-dusk/60 focus:border-gold focus:outline-none pr-11"
            placeholder="••••••••"
          />
        </app-password-field>
      </div>

      @if (errorMessage()) {
        <p class="rounded border border-wax/40 bg-wax/10 px-4 py-3 text-sm text-parchment">
          {{ errorMessage() }}
        </p>
      }

      @if (needsVerification()) {
        <div class="flex flex-col gap-2 text-sm">
          <button
            type="button"
            (click)="resendVerification()"
            [disabled]="resending()"
            class="self-start font-medium text-gold hover:underline disabled:cursor-not-allowed disabled:opacity-60"
          >
            {{ resending() ? 'Sending…' : 'Resend verification email' }}
          </button>
          @if (resendMessage()) {
            <p class="text-dusk">{{ resendMessage() }}</p>
          }
        </div>
      }

      <button
        type="submit"
        [disabled]="submitting()"
        class="mt-2 inline-flex items-center justify-center rounded-[3px] bg-gradient-to-b from-gold to-gold-dim px-6 py-3 text-sm font-bold text-ink transition hover:-translate-y-px disabled:cursor-not-allowed disabled:opacity-60"
      >
        {{ submitting() ? 'Logging in…' : 'Log In' }}
      </button>
    </form>

    <p class="mt-6 text-center text-sm text-dusk">
      New to Ghoul Pool?
      <a routerLink="/register" class="font-medium text-parchment hover:underline">Start free</a>
    </p>
  </div>
</section>
